export default __webpack_public_path__ + "static/media/telegram.2bac0916.svg";